<script>
import { mapGetters } from 'vuex'

import appHeaderInfo from '@/components/app-header/app-header-info'
import appHeaderFilter from '@/components/app-header/app-header-filter'
import AppHeaderInfo from '@/components/app-header/app-header-info'
import AppHeaderFilter from '@/components/app-header/app-header-filter'

export default {
  name: 'app-header',
  components: { AppHeaderFilter, AppHeaderInfo },
  comments: { appHeaderInfo, appHeaderFilter, AppHeaderFilter },
  props: {
    isHeaderHidden: Boolean,
    isMobileVersion: Boolean
  },
  computed: {
    ...mapGetters({
      account: 'account/getAccount',
      options: 'leads/getOptions',
      isLoadedFilters: 'isLoadedFilters',
      showAll: 'showAll',
    }),
    headerStyles() {
      const isHidden = this.isMobileVersion && this.isHeaderHidden && !this.isLoadedFilters
      const isFlex = (
        !this.isMobileVersion
        || (this.isMobileVersion && !this.isHeaderHidden)
        || this.isLoadedFilters
      )
      const full = this.isMobileVersion && this.isLoadedFilters

      return {
        hidden: isHidden,
        flex: isFlex,
        'h-full': full
      }
    }
  },
}
</script>

<template>
  <header 
    class="flex-col ww-sticky top-0 left-0 right-0 z-10 bg-card"
    :class="headerStyles"
  >
    <div class="h-12 bg-white">
      <div class="container">
        <app-header-info
          :account="account"
          :isMobileVersion="isMobileVersion"
        />
      </div>
    </div>
    <div class="py-3">
      <div class="container">
        <app-header-filter
          :options="account.options"
          :currency="account.numberFormat?.currency"
          :isMobileVersion="isMobileVersion"
        />
      </div>
    </div>
  </header>
</template>

<style scoped>
  .ww-sticky {
    position: sticky !important;
  }
</style>>